export const brands= [
    {
        "id":1, 
        "img":"https://cms-contents.pharmeasy.in/carousel_item/93dac6224e1-web.jpg?dim=146x0&dpr=2&q=100",
    },
    {
        "id":2, 
        "img":"https://cms-contents.pharmeasy.in/carousel_item/fd17e547883-Horlicks_web.jpg?dim=146x0&dpr=2&q=100",
    },
    {
        "id":3, 
        "img":"https://cms-contents.pharmeasy.in/carousel_item/f7a36c06aed-web_Dettol.jpg?dim=146x0&dpr=2&q=100",
    },
    {
        "id":4, 
        "img":"https://cms-contents.pharmeasy.in/carousel_item/c572570b5ce-Liveasy.jpg?dim=146x0&dpr=2&q=100",
    },
    {
        "id":5, 
        "img":"https://cms-contents.pharmeasy.in/carousel_item/c72feb4bd7a-web_Huggies.jpg?dim=146x0&dpr=2&q=100",
    },
    {
        "id":6, 
        "img":"https://cms-contents.pharmeasy.in/carousel_item/fee433dea2d-web.jpg?dim=146x0&dpr=2&q=100",
    },
    {
        "id":7, 
        "img":"https://cms-contents.pharmeasy.in/carousel_item/2d987111a15-Featured-banner_Revital.png?dim=146x0&dpr=2&q=100",
    },
    {
        "id":8, 
        "img":"https://cms-contents.pharmeasy.in/carousel_item/ac01791d842-Featured-banner_Volini.png?dim=146x0&dpr=2&q=100",
    },
    {
        "id":9, 
        "img":"https://cms-contents.pharmeasy.in/carousel_item/7e5e174fdfb-OneTouchWeb.jpg?dim=146x0&dpr=2&q=100",
    },
    {
        "id":10, 
        "img":"https://cms-contents.pharmeasy.in/carousel_item/db82ec1a424-web_Curatio.jpg?dim=146x0&dpr=2&q=100",
    },
    {
        "id":11, 
        "img":"https://cms-contents.pharmeasy.in/carousel_item/7fdd90400a1-Featured-banner-Hansaplast-web.png?dim=146x0&dpr=2&q=100",
    },
    {
        "id":12, 
        "img":"https://cms-contents.pharmeasy.in/carousel_item/6beabc4b6ed-web_Accusure.jpg?dim=146x0&dpr=2&q=100",
    },
    {
        "id":13, 
        "img":"https://cms-contents.pharmeasy.in/carousel_item/0e3affec097-The_Natural_Wash_Dweb.jpg?dim=146x0&dpr=2&q=100",
    },
    {
        "id":14, 
        "img":"https://cms-contents.pharmeasy.in/carousel_item/f8493a13be2-web_Pigeon.jpg?dim=146x0&dpr=2&q=100",
    },
    {
        "id":15, 
        "img":"https://cms-contents.pharmeasy.in/carousel_item/0845572266f-Everherb.jpg?dim=146x0&dpr=2&q=100",
    },
    {
        "id":16, 
        "img":"https://cms-contents.pharmeasy.in/carousel_item/22256dfc61d-web_Themomosco.jpg?dim=146x0&dpr=2&q=100",
    },
    {
        "id":17, 
        "img":"https://cms-contents.pharmeasy.in/carousel_item/4570d49a57c-Bella.jpg?dim=146x0&dpr=2&q=100",
    },
    {
        "id":18, 
        "img":"https://cms-contents.pharmeasy.in/carousel_item/760a5f6f612-web_sirona.jpg?dim=146x0&dpr=2&q=100",
    },
    {
        "id":19, 
        "img":"https://cms-contents.pharmeasy.in/carousel_item/1faa7b6995e-Pentasure_Dweb.jpg?dim=146x0&dpr=2&q=100",
    },
]